/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} produktů`
};

const da_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} produkter`
};

const de_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Produkte`
};

const en_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} items`
};

const es_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} productos`
};

const fr_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} produits`
};

const hu_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} termék`
};

const it_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} prodotti`
};

const nl_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} producten`
};

const pl_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} produktów`
};

const pt_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} produtos`
};

const sv_items_count = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} produkter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const items_count = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.items_count(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("items_count", locale)
	if (locale === "cs") return cs_items_count(inputs)
	if (locale === "da") return da_items_count(inputs)
	if (locale === "de") return de_items_count(inputs)
	if (locale === "en") return en_items_count(inputs)
	if (locale === "es") return es_items_count(inputs)
	if (locale === "fr") return fr_items_count(inputs)
	if (locale === "hu") return hu_items_count(inputs)
	if (locale === "it") return it_items_count(inputs)
	if (locale === "nl") return nl_items_count(inputs)
	if (locale === "pl") return pl_items_count(inputs)
	if (locale === "pt") return pt_items_count(inputs)
	return sv_items_count(inputs)
};